import React, { Component } from "react";
import RZSkillDetailItem from "./RZSkillDetailItem";
import { AlexaCommon } from "utils/Common";
const autoBind = require("auto-bind");

class RZSkillMasterItem extends React.Component {
  /**
   * @param {Object} props
   * @example
   * iconSrc
   * title
   * subTitle
   * expandText
   * closeText
   * list
   */
  constructor(props) {
    super(props);
    autoBind(this);
    this.avsWrapper = this.props.avsWrapper;
    this.state = {
      isShowDetail: false,
    };
  }

  onClickExpandButton(event) {
    this.setState({
      isShowDetail: !this.state.isShowDetail,
    });
  }

  //override
  componentDidUpdate(prevProps, prevState) {}

  renderDetailItem() {
    let detailItem = "";
    if (
      AlexaCommon.isArrayNotNullAndNotEmpty(this.props.list) &&
      this.state.isShowDetail
    ) {
      detailItem = <RZSkillDetailItem list={this.props.list} />;
    }
    return detailItem;
  }

  renderExpandButton() {
    let expandButton = "";
    let buttonText = this.state.isShowDetail
      ? this.props.closeText
      : this.props.expandText;
    if (AlexaCommon.isArrayNotNullAndNotEmpty(this.props.list)) {
      expandButton = (
        <div className="item-expand alexa-padding-10">
          <div
            className="expand-btn alexa-underline-special-btn center-align-ellipsis"
            onClick={this.onClickExpandButton}
          >
            {buttonText}
          </div>
        </div>
      );
    }
    return expandButton;
  }

  render() {
    let detailItem = this.renderDetailItem();
    let expandButton = this.renderExpandButton();
    return (
      <div className="skill-full-item-container">
        <div className="skill-item-container skill-master">
          <div className="skill-item-content alexa-padding-10 alexa-flex-row-center-jleft">
            <div className="item-icon alexa-padding-10">
              <img className="alexa-icon" src={this.props.iconSrc}></img>
            </div>
            <div
              className="item-text alexa-padding-10"
              style={{ width: "751px" }}
            >
              <div className="item-title">{this.props.title}</div>
              <div
                className="item-subtitle"
                dangerouslySetInnerHTML={{ __html: this.props.subTitle }}
              />
            </div>
            {expandButton}
          </div>
        </div>
        {detailItem}
      </div>
    );
  }
}

export default RZSkillMasterItem;
